import { withCloseAfterExited } from "../modal";
import {
  default as View,
  RevokeInvitationModalProps
} from "./revoke-invitation-modal-view";

const RevokeInvitationModal = withCloseAfterExited<RevokeInvitationModalProps>(
  View
);
export default RevokeInvitationModal;
